import { render, staticRenderFns } from "./TradeRequestInformation.vue?vue&type=template&id=ee1be88a"
import script from "./TradeRequestInformation.vue?vue&type=script&lang=js"
export * from "./TradeRequestInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports